import { AreainfoList } from './AreainfoList'
import { AreainfoEdit } from './AreainfoEdit'
import { AreainfoCreate } from './AreainfoCreate'

export { AreainfoList, AreainfoEdit, AreainfoCreate }


// WEBPACK FOOTER //
// ./src/components/areainfo/index.js